export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyDlgUHdPvXQIA6XSHSBqfH8u4gS0P6ftn4",
  authDomain: "cellsbin.firebaseapp.com",
  projectId: "cellsbin",
  storageBucket: "cellsbin.firebasestorage.app",
  messagingSenderId: "352111501275",
  appId: "1:352111501275:web:12b9aad1f31b235d1b91fe",
}

export const THEMES = [
  { key: "light", label: "Light", default: true },
  { key: "dark", label: "Dark" },
]
